<div class="externe-daten">
  <cap-content-header>
    <cap-title>
      {{ "gwrGebaeude.SucheTitel" | translate }}
    </cap-title>
  </cap-content-header>

  <ul [(activeId)]="searchMode" #nav="ngbNav" class="nav-tabs" ngbNav>
    <li [ngbNavItem]="'searchStandard'">
      <a ngbNavLink>{{ "Standardsuche" | translate }}</a>
      <ng-template id="standard" ngbNavContent>
        <cap-gwr-gebaeude-suche-standard></cap-gwr-gebaeude-suche-standard>
      </ng-template>
    </li>

    <li [ngbNavItem]="'searchFachId'">
      <a ngbNavLink>{{ "EGID" | translate }}</a>
      <ng-template id="erweitert" ngbNavContent>
        <cap-gwr-gebaeude-suche-egid></cap-gwr-gebaeude-suche-egid>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
